<section>
  <div *ngIf="type == 'ACCOUNT_OWNER'">
    <div>
      <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!errorMessage">{{errorMessage}}</div>
      <h2 style="margin-bottom: 1.5rem!important;">Get Started!</h2>
      <form class="needs-validation" novalidate>
        <div class="form-group">
          <input type="text" id="nameAcc" [(ngModel)]="register.name" class="form-control" (blur)="createName()"
                 [ngClass]="{'is-invalid':nameError}"
                 [ngModelOptions]="{standalone: true}" placeholder="Name" required>
          <div id="nameErrorACC" class="invalid-feedback d-block shift-invalid-login" [hidden]="!nameError">
            {{nameError}}
          </div>
        </div>
        <div class="form-group">
          <input type="text" id="emailAcc" [(ngModel)]="register.email" class="form-control"
                 [ngClass]="{'is-invalid':emailError}" (blur)="validateEmail()" placeholder=""
                 [ngModelOptions]="{standalone: true}" placeholder="Email" required>
          <div id="emailErrorAcc" class="invalid-feedback d-block shift-invalid-login" [hidden]="!emailError">
            {{emailError}}
          </div>
        </div>
        <div class="form-group">
          <input type="text" id="phoneAcc" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                 [(ngModel)]="register.mobile" (blur)="validateMobile()" maxlength="10" class="form-control"
                 placeholder="Phone Number" [ngClass]="{'is-invalid':phoneError}" [ngModelOptions]="{standalone: true}"
                 required>
          <div id="phoneErrorAcc" class="invalid-feedback d-block shift-invalid-login" [hidden]="!phoneError">
            {{phoneError}}
          </div>
        </div>
        <div class="form-group">
          <input type="text" id="compAcc" [(ngModel)]="register.companyName" class="form-control"
                 [ngModelOptions]="{standalone: true}" (blur)="validateCompany()"
                 [ngClass]="{'is-invalid':companyError}" placeholder="Company Name" required>
          <div id="companyErrorAcc" class="invalid-feedback d-block shift-invalid-login" [hidden]="!companyError">
            {{companyError}}
          </div>
        </div>
        <button type="submit" (click)="registerSubmit()" class="btn btn-orange btn-block">Submit</button>
        <a routerLink="/access/login" class="google-btn mt-2">Back To Login</a>
      </form>
    </div>
  </div>
</section>
